import type { UseMutationResult } from '@tanstack/react-query'
import { BoolIcon } from '@/components/common/BoolIcon'
import {
  useTaskDocumentTypes,
  useCreateTaskDocumentType,
  useUpdateTaskDocumentType,
  useDeactivateTaskDocumentType,
} from '@/features/tasks/hooks'
import type { DocumentType } from '@/features/tasks/types'
import type { DictionaryPanelConfig } from '../DictionaryPanel'

export const documentTypesConfig: DictionaryPanelConfig<DocumentType> = {
  title: 'Typy dokumentów',
  description: 'Kategorie dokumentów w załącznikach zadań (np. Faktura, Zdjęcie, Protokół).',
  addLabel: 'Dodaj typ dokumentu',
  deleteSemantics: 'soft',  // backend: set is_active=false; istniejące pliki zachowują snapshot label
  useList: useTaskDocumentTypes,
  useCreate: () => {
    const m = useCreateTaskDocumentType()
    return {
      ...m,
      mutate: (payload: Record<string, unknown>, opts?: Parameters<typeof m.mutate>[1]) =>
        m.mutate(
          {
            code: String(payload['code'] ?? ''),
            label: String(payload['label'] ?? ''),
          },
          opts,
        ),
    } as unknown as UseMutationResult<DocumentType, Error, Record<string, unknown>>
  },
  useUpdate: () => {
    const m = useUpdateTaskDocumentType()
    return {
      ...m,
      mutate: (
        vars: { code: string; patch: Record<string, unknown> },
        opts?: Parameters<typeof m.mutate>[1],
      ) =>
        m.mutate(
          { code: vars.code, patch: { label: String(vars.patch['label'] ?? '') } },
          opts,
        ),
    } as unknown as UseMutationResult<DocumentType, Error, { code: string; patch: Record<string, unknown> }>
  },
  useDeactivate: useDeactivateTaskDocumentType,
  columns: [
    { key: 'code', header: 'Kod', className: 'font-mono text-slate-500 w-40' },
    { key: 'label', header: 'Etykieta' },
    { key: 'isActive', header: 'Aktywne', render: (t) => BoolIcon({ value: t.isActive }) },
  ],
  formFields: [
    { key: 'code', label: 'Kod (UPPERCASE)', type: 'code', required: true },
    { key: 'label', label: 'Etykieta', type: 'text', required: true },
  ],
}
